<template>
  <div id="solutions" class="section">
    <div class="container">
      <article class="col s12">
        <h3 class="is-size-3">{{ $t("solutions.tittle") }}</h3>
        <hr class="line" />
      </article>
      <br />
      <article class="grid" id="grid-solutions-row-1">
        <div
          class="card hover-efx hover-card"
          v-for="(item, index) in $t('solutions.row1')"
          :key="index"
        >
          <div
            data-aos="fade-up"
            :data-aos-delay="'1' + index + 1 + '0'"
            data-aos-duration="100"
            @click="toModule(item.id)"
          >
            <div class="card-content">
              <div class="">
                <p class="is-size-4 has-text-centered">
                  <img
                    v-bind:src="getImgUrl(item.icon)"
                    :alt="item.id"
                    style="height: 100px; vertical-align: bottom"
                  />
                </p>
                <p class="is-size-4 has-text-centered">
                  {{ item.name }}
                </p>
                <p class="has-text-centered">
                  {{ item.copy }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
export default {
  name: "Solutions",
  methods: {
    getImgUrl(icon) {
      return require(`@/assets/icon/${icon}.png`);
    },
    toModule(id) {
      this.$router.push({
        path: `/modules/${id}`,
      });
    },
  },
};
</script>
<style scoped>
.grid {
  gap: 1rem;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
}
</style>
<i18n>
{
  "es": {
    "solutions":{
      "tittle": "Módulos",
      "descript": "=",
      "row1":[
          { 
            "id":"aml_compliance",
            "name":"AML/Compliance",
            "icon":"compliance",
            "copy":"Detecta operaciones de lavado de dinero, corrupción o financiamiento del terrorismo."
          },
          { 
            "id":"fraud_prevention",
            "name":"Prevención de fraude",
            "icon":"fraud",
            "copy":" Identifica comportamientos potencialmente abusivos por parte de colaboradores, clientes o terceras partes implementando un conjunto de reglas para detectar prácticas fraudulentas."
          },
          { 
            "id":"market_abuse",
            "name":"Abuso de mercado",
            "icon":"market",
            "copy":"Detecta patrones e identifica situaciones sospechosas de uso de información privilegiada, conflicto de interés y transacciones entre partes relacionadas, entre otros."
          },
          {
            "id":"continuous_audit",
            "name":"Auditoría continua",
            "icon":"audit",
            "copy":"Apoyar con tecnología la ejecución de controles preventivos y específicos de la organización que se levanten dentro de un programa de auditoría continua para detectar a tiempo comportamientos inusuales."
          },
          {
            "id":"complaints_channel",
            "name":"Portal ético",
            "icon":"channel",
            "copy":"Es un canal de denuncias automatizado, transparente y confidencial para colaboradores, proveedores y clientes."
          },
          {
            "id":"management_indicators",
            "name":"Monitoreo de procesos",
            "icon":"monitor",
            "copy":"Permite identificar cuando alguna variable existente en un proceso presenta una desviación significativa lo cual genera deficiencia."
          }
        ]
    }
  },
  "en": {
      "solutions":{
      "tittle": "Modules",
      "descript": "=",
      "row1":[
          { 
            "id":"aml_compliance",
            "name":"AML/Compliance",
            "icon":"compliance",
            "copy":"Detection of money laundering, corruption or terrorist financing operations."
          },
          { 
            "id":"fraud_prevention",
            "name":"Fraud prevention",
            "icon":"fraud",
            "copy":"Identifies potentially abusive behavior by employees, customers or third parties by implementing a set of rules to detect fraudulent practices."
          },
          { 
            "id":"market_abuse",
            "name":"Market abuse",
            "icon":"market",
            "copy":"Detect patterns and identify suspicious situations of use of privileged information, conflict of interest and transactions between related parties, among others."
          },
          {
            "id":"continuous_audit",
            "name":"Continuous audit",
            "icon":"audit",
            "copy":"Support with technology the execution of preventive and specific controls of the organization that are raised within a continuous audit program to detect unusual behavior in time."
          },
          {
            "id":"complaints_channel",
            "name":"External Complaints Channel",
            "icon":"channel",
            "copy":"It is a confidencial complaints channel, transparent and confidential reporting channel for employees, suppliers and customers."
          },
          {
            "id":"management_indicators",
            "name":"Process monitoring",
            "icon":"monitor",
            "copy":"It allows to identify when any existing variable in a process presents a significant deviation which generates deficiency."
          }
        ]
    }
  },
  "pt": {
      "solutions":{
      "tittle": "Módulos",
      "descript": "=",
      "row1":[
          { 
            "id":"aml_compliance",
            "name":"AML/Compliance",
            "icon":"compliance",
            "copy":"Detectar operações de lavagem de dinheiro, corrupção ou financiamento do terrorismo."
          },
          { 
            "id":"fraud_prevention",
            "name":"Prevenção de fraudes",
            "icon":"fraud",
            "copy":"Identifica comportamentos potencialmente abusivos por parte de colaboradores, clientes ou terceiros através da implementação de um conjunto de regras para detetar práticas fraudulentas."
          },
          { 
            "id":"market_abuse",
            "name":"Abuso de mercado",
            "icon":"market",
            "copy":"Detecta padrões de abuso de mercado e identifica situações suspeitas de uso de informações privilegiadas, entre outras."
          },
          {
            "id":"continuous_audit",
            "name":"Auditoria contínua",
            "icon":"audit",
            "copy":"Apoiar com tecnologia a execução de controles preventivos e específicos da organização que são levantados dentro de um programa de auditoria contínua para detectar comportamentos não usuais a tempo."
          },
          {
            "id":"complaints_channel",
            "name":"Portal Ético",
            "icon":"channel",
            "copy":"É um canal de denúncia automatizado, transparente e confidencial para colaboradores, fornecedores e clientes."
          },
          {
            "id":"management_indicators",
            "name":"Monitoramento de processos industriais",
            "icon":"monitor",
            "copy":"Através do cruzamento de informações relacionadas e da criação de regras personalizáveis, este módulo permite identificar quando alguma variável muda e gerar alertas que identificam o caso."
          }
        ]
    }
  }
}
</i18n>
